/**
 * Validation constants for phone authentication
 */
export const VALIDATION_CONSTANTS = {
  MIN_PHONE_LENGTH: 10,
  MIN_PASSWORD_LENGTH: 6,
  OTP_LENGTH: 6,
  RATE_LIMIT_DELAY_MS: 10000,
};

/**
 * Time intervals in milliseconds
 */
export const TIMING_CONSTANTS = {
  WAIT_TIME_CHECK_INTERVAL_MS: 30000,
};

/**
 * Error types for authentication
 */
export const ERROR_TYPES = {
  RATE_LIMITED: 'Rate limited',
  USER_CANCELLED: 'User cancelled',
  TOO_MANY_REQUESTS: 'Firebase: Error (auth/too-many-requests)',
  INVALID_NUMBER: 'Invalid number',
  USER_CHECK_ERROR: 'User check error',
  SIGNUP_ERROR: 'Signup error',
};

/**
 * Firebase storage and localStorage keys
 */
export const FIREBASE_STORAGE_KEYS = {
  RETRY_AFTER: 'firebase_retry_after',
  LAST_ATTEMPT_DATE: 'lastAttemptDate',
  LOCK_UNTIL: 'lockUntil',
  PREV_LOGIN_PAGE: 'PREV_LOGIN_PAGE',
  IS_NEW_PWA: 'isNewPWA',
};

/**
 * User messages
 */
export const USER_MESSAGES = {
  INVALID_NUMBER: 'Numéro invalide',
  INCORRECT_CODE: 'Code incorrect',
  VERIFICATION_ERROR: 'Erreur lors de la vérification du code',
  PASSWORD_TOO_SHORT: 'Le mot de passe doit contenir au moins 6 caractères',
  PASSWORDS_DONT_MATCH: 'Les mots de passe ne correspondent pas',
  WAIT_BEFORE_RETRY: (minutes) => `Veuillez attendre ${minutes} minute(s) avant de réessayer.`,
  USER_CHECK_ERROR: 'Erreur lors de la vérification du numéro',
  UNEXPECTED_ERROR: 'Erreur inattendue',
};

/**
 * Authentication steps
 */
export const AUTH_STEPS = {
  PHONE_INPUT: 1,
  OTP_VERIFICATION: 2,
  PASSWORD_SETUP: 3,
  FORGOT_PASSWORD: 'forgot',
};

